import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  AlertDialogProps,
  Button,
  Heading,
  Text,
  VStack,
} from '@chakra-ui/react';
import React, { useRef } from 'react';

export type DialogModalProps = {
  headline: string;
  text?: string;
  confirmButtonText: string;
  closeButtonText: string;
  onConfirm: () => void;
  onClose: () => void;
} & Omit<AlertDialogProps, 'children' | 'leastDestructiveRef'>;

export const DialogModal: React.FC<DialogModalProps> = ({
  headline,
  text,
  confirmButtonText,
  closeButtonText,
  onConfirm,
  onClose,
  ...rest
}) => {
  const leastDestructiveRef = useRef(null);
  return (
    <AlertDialog
      isCentered
      onClose={onClose}
      leastDestructiveRef={leastDestructiveRef}
      {...rest}
    >
      <AlertDialogOverlay>
        <AlertDialogContent px={'8'} py={'6'} m={'7'}>
          <AlertDialogHeader p={0}>
            <Heading
              as={'h2'}
              size={'lg'}
              lineHeight={'8'}
              children={headline}
            />
          </AlertDialogHeader>
          {text && (
            <AlertDialogBody px={0} pt={'2'} pb={0}>
              <Text>{text}</Text>
            </AlertDialogBody>
          )}
          <AlertDialogFooter p={0}>
            <VStack minH={'5.5rem'} w={'full'} spacing={'4'} pt={'8'}>
              <Button
                width={'full'}
                children={confirmButtonText}
                onClick={onConfirm}
              />
              <Button
                variant={'outline'}
                width={'full'}
                children={closeButtonText}
                onClick={onClose}
                ref={leastDestructiveRef}
              />
            </VStack>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};
